import React, { useRef } from 'react';

const NIVEAUX_REMONTEE_MAX = 4;

const trouverProchaineSection = (element) => {
    let courant = element;
    let niveau = 0;

    while (courant && niveau < NIVEAUX_REMONTEE_MAX) {
        if (courant.nextElementSibling) {
            return courant.nextElementSibling;
        }
        courant = courant.parentElement;
        niveau += 1;
    }

    return null;
};

const defilerVersProchaineSection = (element) => {
    if (!element || !element.isConnected) {
        return;
    }

    const prochaine = trouverProchaineSection(element);
    if (!prochaine) {
        return;
    }

    const rect = prochaine.getBoundingClientRect();
    const hauteurFenetre = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top >= 0 && rect.top <= hauteurFenetre * 0.75) {
        return;
    }

    prochaine.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const OuiNonToggle = ({ value, onChange, label, texts, readOnly = false }) => {
    const sectionRef = useRef(null);

    const repondre = (reponse) => {
        onChange(reponse);
        // défilement on oui ou non
        window.requestAnimationFrame(() =>
            window.requestAnimationFrame(() => defilerVersProchaineSection(sectionRef.current))
        );
    };

    return (
        <div className="fec-oui-non-section" ref={sectionRef}>
            {label &&
                <div className="sub-title-section">
                    <span className="droit-acces-span">{label}</span>
                </div>
            }
            <div className="fec-oui-non-holder">
                <button
                    type="button"
                    className={`fec-oui-non-btn ${value === true ? 'selected' : ''}`}
                    disabled={readOnly}
                    onClick={() => !readOnly && value !== true && repondre(true)}
                >
                    {texts.yes}
                </button>
                <button
                    type="button"
                    className={`fec-oui-non-btn ${value === false ? 'selected' : ''}`}
                    disabled={readOnly}
                    onClick={() => !readOnly && value !== false && repondre(false)}
                >
                    {texts.no}
                </button>
            </div>
        </div>
    );
};

export default OuiNonToggle;
